import { useEffect, useCallback } from 'react';

const CustomFieldListeners = ({ eventEmitter, applyStoreAction, delayedApplyStoreAction }) => {
    const customFieldAdded = useCallback(payload => {
        (payload.force ? applyStoreAction : delayedApplyStoreAction)({
            type: 'CUSTOM_FIELD_ADD_SOCKET',
            payload: {
                customField: payload.data || payload
            }
        });
    }, [applyStoreAction. delayedApplyStoreAction]);

    const customFieldEdited = useCallback(customField => {
        applyStoreAction({
            type: 'CUSTOM_FIELD_UPDATE_SOCKET',
            payload: {
                customFieldId: customField.id,
                customField
            }
        });
    }, [applyStoreAction]);

    const listen = () => {
        eventEmitter.on('custom_field_added', customFieldAdded);
        eventEmitter.on('custom_field_edited', customFieldEdited);

        return () => {
            eventEmitter.off('custom_field_added', customFieldAdded);
            eventEmitter.off('custom_field_edited', customFieldEdited);
        };
    };

    useEffect(listen, [eventEmitter, customFieldAdded, customFieldEdited]);

    return null;
}

export default CustomFieldListeners;
